import {
  WipeRunStatus,
  WipeStepStatus,
} from "@redotech/redo-support-v2-migration/execution/wipe-execution-progress";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const DateString = z.string().datetime();

export const SupportV2WipeRunProgress = z.object({
  /** Resolved CRDB account id (INT8) as a string, once known. */
  accountId: z.string().nullable(),
  completedAt: DateString.nullable(),
  createdAt: DateString,
  id: z.string(),
  lastError: z.string().nullable(),
  startedAt: DateString.nullable(),
  status: WipeRunStatus,
  totalDeleted: z.number(),
  updatedAt: DateString,
  workflowId: z.string(),
});
export type SupportV2WipeRunProgress = z.infer<typeof SupportV2WipeRunProgress>;

export const SupportV2WipeStepProgress = z.object({
  completedAt: DateString.nullable(),
  deletedCount: z.number(),
  id: z.string(),
  /** Human label for the wipe target (falls back to the table name). */
  label: z.string(),
  lastError: z.string().nullable(),
  position: z.number(),
  startedAt: DateString.nullable(),
  status: WipeStepStatus,
  tableName: z.string(),
  updatedAt: DateString,
});
export type SupportV2WipeStepProgress = z.infer<
  typeof SupportV2WipeStepProgress
>;

export const getSupportV2WipeProgress = {
  name: "getSupportV2WipeProgress" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    history: z.array(SupportV2WipeRunProgress),
    run: SupportV2WipeRunProgress.nullable(),
    steps: z.array(SupportV2WipeStepProgress),
  }),
};
export type SupportV2WipeProgress = z.infer<
  typeof getSupportV2WipeProgress.output
>;
